import ElPageHeader from './PageHeader.vue'

/* istanbul ignore next */
ElPageHeader.install = function (app) {
  app.component(ElPageHeader.name, ElPageHeader)
}

export default ElPageHeader
